/* eslint-disable no-invalid-this */
import { error } from 'app/infrastructure/log';
import { parseAsDateUTC } from '../data/date';

/**
 * Wrapper for JSON.stringify to 
 * 
 * - handle errors 
 * - avoiding circular reference errors
 * - ignore functions
 * - ensure that Date objects where created correctly 
 */
export function toJSON(obj: any, space?: string | number){
  try{

    if ( obj instanceof Error ){
      return JSON.stringify(obj, ['message', 'arguments', 'type', 'name', 'stack', 'response']);
    }

    if ( obj instanceof Response ){
      return JSON.stringify({ statusText: obj.statusText, status: obj.status, url: obj.url, type: obj.type });
    }

    return JSON.stringify(obj, serializer((key: string, value: any): any => {

      if (Array.isArray(value)){
        return value.filter(v => v || v === 0 || v === false);
      }
 
      return value;

    }, null), space);

  } catch (err) {
    error(err);
  }
  return '';
}

/**
 * Deserialize and object from a JSON string, handling JavaScript Date values
 */
export function fromJSON(json: string) {
  if (undefined === json) {
    return undefined;
  }
  try {
    return JSON.parse(json, (key: any, value: any) => {
      return parseAsDateUTC(value) || value;
    });
  } catch (err){
    error(err);
  }
  return undefined;
}

/**
 * NOTE the function returned is stateful, do not re-use it in the calling function
 * 
 * Copyright (c) Isaac Z. Schlueter and Contributors
 * https://github.com/isaacs/json-stringify-safe
 */
function serializer(replacer: any, cycleReplacer: any) {
  const stack: any = [];
  const keys: any = [];

  if (cycleReplacer == null){
     cycleReplacer = (key: any, value: any) => {
                      if (stack[0] === value) {
                        return '[Circular ~]';
                      }
                      return '[Circular ~.' + keys.slice(0, stack.indexOf(value)).join('.') + ']';
                    };
  }

  return function(key: any, value: any) {
    if (stack.length > 0) {
      const thisPos = stack.indexOf(this);
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
      if (~stack.indexOf(value)) {
        value = cycleReplacer.call(this, key, value);
      }
    }
    else {
      stack.push(value);
    }

    return replacer == null ? value : replacer.call(this, key, value);
  };
}
